import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, firstValueFrom } from 'rxjs';
import { OrderService } from '../../services';
import { TalcColor } from 'src/app/shared';

@Injectable({
  providedIn: 'root',
})
export class ColorsResolver  {
  constructor(private ordersService: OrderService) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<TalcColor[]> {
    try {
      return await firstValueFrom(this.ordersService.getTalcColors());
    } catch (e) {
      return [];
    }
  }
}
